<template>
  <vue-recaptcha
    :sitekey="this.$store.state.g2wEnv.current.recaptcha.sitekey"
    :loadRecaptchaScript="true"
    size="invisible"
    recaptchaHost="www.recaptcha.net"
    @expired="$emit('expired')"
    @verify="onToken"
    ref="recaptcha"
  ></vue-recaptcha>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: "captcha",

  components: {
      VueRecaptcha
  },

  methods: {
    execute() {
      this.$refs.recaptcha.execute();
    },

    onToken(token) {
      this.$emit('onCaptchaToken', token);
    }
  }
}
</script>

<style scoped>

</style>
